import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-guilderland-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-guilderland-ny", statusCode: 301 });
  },
});
